import React, { useState, createContext, useContext } from "react";

export const FormDataContext = createContext(null);
export const useFormData = () => useContext(FormDataContext);

export const FormDataProvider = ({ children }) => {
  const [contractFormData, setContractFormData] = useState({
    name: "", sector: "", subsector: "", framework: "", delivery_model: "",
    risk_description: "", contract_value: "", duration_months: "",
    employer_name: "", contractor_name: "", project_type: "",
    start_date: "", end_date: ""
  });
  const [riskAnalysisData, setRiskAnalysisData] = useState({ selectedContract: "", analysis: null });
  const [changeManagementData, setChangeManagementData] = useState({ selectedContract: "", changes: [], summary: null });
  const [timelineData, setTimelineData] = useState({ selectedContract: "", contractTimeline: null, worksTimeline: null });
  const [copilotData, setCopilotData] = useState({ messages: [], conversationContext: {} });
  const [pmToolsData, setPmToolsData] = useState({ selectedSchedule: "", scheduleData: null });

  const resetAllFormData = () => {
    setContractFormData({ name: "", sector: "", subsector: "", framework: "", delivery_model: "", risk_description: "", contract_value: "", duration_months: "", employer_name: "", contractor_name: "", project_type: "", start_date: "", end_date: "" });
    setRiskAnalysisData({ selectedContract: "", analysis: null });
    setChangeManagementData({ selectedContract: "", changes: [], summary: null });
    setTimelineData({ selectedContract: "", contractTimeline: null, worksTimeline: null });
    setCopilotData({ messages: [], conversationContext: {} });
    setPmToolsData({ selectedSchedule: "", scheduleData: null });
  };

  const resetContractForm = () => setContractFormData({ name: "", sector: "", subsector: "", framework: "", delivery_model: "", risk_description: "", contract_value: "", duration_months: "", employer_name: "", contractor_name: "", project_type: "", start_date: "", end_date: "" });
  const resetRiskAnalysis = () => setRiskAnalysisData({ selectedContract: "", analysis: null });
  const resetChangeManagement = () => setChangeManagementData({ selectedContract: "", changes: [], summary: null });
  const resetTimelines = () => setTimelineData({ selectedContract: "", contractTimeline: null, worksTimeline: null });
  const resetCopilot = () => setCopilotData({ messages: [], conversationContext: {} });
  const resetPmTools = () => setPmToolsData({ selectedSchedule: "", scheduleData: null });

  return (
    <FormDataContext.Provider value={{
      contractFormData, setContractFormData, resetContractForm,
      riskAnalysisData, setRiskAnalysisData, resetRiskAnalysis,
      changeManagementData, setChangeManagementData, resetChangeManagement,
      timelineData, setTimelineData, resetTimelines,
      copilotData, setCopilotData, resetCopilot,
      pmToolsData, setPmToolsData, resetPmTools,
      resetAllFormData
    }}>
      {children}
    </FormDataContext.Provider>
  );
};
